

/// <reference path="StockNote.ts" />

// Generated class InternalOutputNote_ManagedObject

class InternalOutputNote_ManagedObject extends StockNote
{
}
